import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { FunctionComponent } from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import type { UseQueryResult } from 'react-query';
import type { HotlineMetaData } from '../../modules/algebra/global';

const Footer: FunctionComponent<{site?: string,statusQuery?:UseQueryResult<HotlineMetaData>}> = () => {
  return (
    <div>
      <Typography component="div" className="hotline-footer">
        <Container maxWidth={false}>
          <Grid container direction="row" spacing={0}>
            <Grid item md={12} className="">
              <Typography component="h6" className="text-center text-tc-1 py-5 font-notosans">
                Find help and the resources you need. Call
                <Link href="tel:800.656.4673" className="font-bold text-tc-1 ml-1">
                  800.656.4673
                </Link>
              </Typography>
            </Grid>
            <Grid item md={12} className="p-0">
              <Divider orientation="horizontal" variant="fullWidth" />
            </Grid>
            <Grid item sm={5} className="">
              <Typography component="p" className="font-bold text-base text-blue-100 my-3 mt-3">
                Get RAINN updates
              </Typography>
              <Grid container alignItems="flex-start" spacing={2}>
                <Grid item xs={6}>
                  <TextField className="input-footer" placeholder="First Name" fullWidth />
                </Grid>
                <Grid item xs={6}>
                  <TextField className="input-footer" placeholder="Last Name" fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Typography component="div" className="flex">
                    <TextField className="input-footer with-button" placeholder="Email Address" fullWidth />
                    <Button className="button-footer-form">Sign Up</Button>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={2} className=""></Grid>
            <Grid item md={5} className="">
              <List className="grid grid-cols-3 p-4 footer-links">
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/contact-us">Contact</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/press">Press</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/leadership-and-governance">Leadership</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/statistics-landing">Statistics</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/careers">Jobs</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/news">News</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/get-involved">Volunteer</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://rainn.org/student-activism">Take Action</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://www.rainn.org/about-rainn">About RAINN</Link>
                </ListItem>
                <ListItem className="col-span-1">
                  <Link href="https://store.rainn.org/">Store</Link>
                </ListItem>
              </List>
            </Grid>
            <Grid item md={12} className="p-0">
              <Divider orientation="horizontal" variant="fullWidth" />
            </Grid>
            <Grid item md={12} className="py-3">
              <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
                <Grid item className="">
                  <List className="flex social-icon">
                    <ListItem disableGutters>
                      <Link href="https://www.facebook.com/RAINN01/">
                        <FaFacebookF className="text-white text-lg" />
                      </Link>
                    </ListItem>
                    <ListItem disableGutters>
                      <Link href="https://twitter.com/rainn01">
                        <FaTwitter className="text-white text-lg" />
                      </Link>
                    </ListItem>
                    <ListItem disableGutters>
                      <Link href="https://www.instagram.com/rainn01/">
                        <FaInstagram className="text-white text-lg" />
                      </Link>
                    </ListItem>
                    <ListItem disableGutters>
                      <Link href="https://www.youtube.com/user/RAINN01">
                        <FaYoutube className="text-white text-lg" />
                      </Link>
                    </ListItem>
                  </List>
                </Grid>
                <Grid item className="">
                  <Link href="https://donate.rainn.org/donate" className="donation-btn">
                    <Button className="button-footer-signup">Support RAINN with a donation today.</Button>
                  </Link>
                </Grid>
                <Grid item></Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Typography component="div" className="copyright-links">
          <Container>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} className="flex flex-wrap justify-start md:justify-center">
              <List className="flex flex-col md:flex-row">
                <ListItem disableGutters>
                  <Link href="https://www.rainn.org">© RAINN 2021</Link>
                </ListItem>
                <ListItem disableGutters>
                  <Link href="https://www.rainn.org/online-privacy-policy">Privacy Policy</Link>
                </ListItem>
                <ListItem disableGutters>
                  <Link href="https://rainn.org/federal-funding-disclaimer">Federal Funding Disclaimer</Link>
                </ListItem>
              </List>
            </Grid>
          </Container>
        </Typography>
      </Typography>
    </div>
  );
};

export default Footer;
